import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HeaderContext } from "@context/HeaderContext";

const SupportLeftMenu = () => {
  const { setSubMenu } = useContext(HeaderContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = (menuName) => {
    setSubMenu(menuName);

    switch (menuName) {
      // case "공지사항":
      //   navigate("/support/notice");
      //   break;
      case "Q & A":
        navigate("/support/qna");
        break;
      case "자료실":
        navigate("/support/reference");
        break;
      // case "1:1문의":
      //   navigate("/support/inquiry");
      //   break;
      default:
        break;
    }
  };

  const currentPath = location.pathname;

  const menuItems = [
    // {
    //   name: "공지사항",
    //   path: "/support/notice",
    // },
    {
      name: "Q & A",
      path: "/support/qna",
    },
    {
      name: "자료실",
      path: "/support/reference",
    },
    // {
    //   name: "1:1문의",
    //   path: "/support/inquiry",
    // },
  ];

  return (
    <div className="left-menu">
      <h2>학습지원센터</h2>
      <div>
        <ul>
          {menuItems.map((item) => (
            <li
              key={item.name}
              onClick={() => handleMenuClick(item.name)}
              className={
                currentPath.startsWith(item.path) ? "sub-menu-on" : ""
              }
            >
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SupportLeftMenu;
